import React from 'react';
import { siteConfig } from '../../config/siteConfig';
import './ScrollingBanner.css';

const ScrollingBanner = () => {
  const { hero } = siteConfig;

  return (
    <>
        {/* <div className="newsletter-section-spacer" /> */}
        <section className="scrolling-banner">
        <div className="scrolling-banner-content">
            <div className="scrolling-text" data-speed={hero.scrollingBanner.speed}>
            <span className="scrolling-banner-text">
                {Array(20).fill(`${hero.scrollingBanner.text} • `).join('')}
            </span>
            </div>
        </div>
        </section>
    </>
  );
};

export default ScrollingBanner; 